import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';
import { SubscriptionItem } from 'src/features/subscriptionItems/utils/types';

const RESOURCE = '/subscriptions/subscription/:subscriptionId/subscription-item/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    subscriptionId: string;
}

const queryFn = ({ subscriptionId, ...params }: DTO): Promise<ListResponseAPI<SubscriptionItem>> => {
    return axios.get(formatResourcePath(RESOURCE, { subscriptionId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_SUBSCRIPTION_ITEMS_RESOURCE, useQueryHook as useListSubscriptionItems };
